import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserOrderExternalManagedPaymentDetailsRequestSchema,
  GetUserOrderExternalManagedPaymentDetailsRequestType,
  UserOrderExternalManagedPaymentDetailsResponseSchema,
  UserOrderExternalManagedPaymentDetailsResponseType
} from '../../../services/NwExternalPaymentsServices/APIService/types';

import { useNwExternalPaymentsService } from '../useNwExternalPaymentsService';

interface UseGetUserOrderExternalManagedPaymentDetailsApiInterface {
  getUserOrderExternalManagedPaymentDetailsApi: (
    input: GetUserOrderExternalManagedPaymentDetailsRequestType
  ) => Promise<UserOrderExternalManagedPaymentDetailsResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetUserOrderExternalManagedPaymentDetailsApi =
  (): UseGetUserOrderExternalManagedPaymentDetailsApiInterface => {
    const { nwExternalPaymentsServiceInstance } = useNwExternalPaymentsService();

    const getUserOrderExternalManagedPaymentDetails = (
      requestObject: GetUserOrderExternalManagedPaymentDetailsRequestType
    ) => {
      try {
        GetUserOrderExternalManagedPaymentDetailsRequestSchema.parse(
          requestObject
        );
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwExternalPaymentsServiceInstance
        .getUserOrderExternalManagedPaymentDetails(requestObject)
        .then((response) => {
          try {
            UserOrderExternalManagedPaymentDetailsResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
      getUserOrderExternalManagedPaymentDetails,
      {
        mutationKey: ['getUserOrderExternalManagedPaymentDetailsApi']
      }
    );

    return {
      getUserOrderExternalManagedPaymentDetailsApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useGetUserOrderExternalManagedPaymentDetailsApi };
